import React from 'react';
import { List, Typography, Empty } from 'antd';
import { Link } from 'react-router-dom';
import { UnauthenticatedLayout } from '../layout/UnauthenticatedLayout';
import { createUseStyles } from 'react-jss';
import { useCookies } from 'react-cookie';
import config from '../config';
const { REFRESH_TOKEN_NAME, ACCESS_TOKEN_NAME, PARTNER_COOKIE_NAME } = config;

const { Text } = Typography;

const useStyles = createUseStyles({
  card: {
    width: '400px',
  },
});
export const Session = () => {
  const classes = useStyles();
  const [cookies, , removeCookie] = useCookies([ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME, PARTNER_COOKIE_NAME, 'pids']);
  type KeyType = keyof typeof cookies;
  const keys = Object.keys(cookies) as KeyType[];
  const clearAllCookies = () => {
    keys.forEach((key: KeyType) => {
      removeCookie(key);
    });
  };
  const cardActions = [
    <Link to="/login">Return to Login</Link>,
    <span onClick={clearAllCookies}>Clear All Cookies</span>,
  ];

  return (
    <UnauthenticatedLayout title={'Session Cookies'} className={classes.card} actions={cardActions}>
      <List>
        {keys.map((key) => (
          <List.Item>
            <List.Item.Meta
              description={
                <Text code copyable={{ text: cookies[key] }}>
                  {cookies[key]}
                </Text>
              }
              title={<b>{key}</b>}
            />
          </List.Item>
        ))}
      </List>
      {keys.length < 1 && <Empty description={'No Session Cookies Defined'} />}
    </UnauthenticatedLayout>
  );
};

export default Session;
